
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IReportCreateResponse, IReportsListResponse, IReportUploadPayload, IJobsPeriodRow, IRevenuePeriodRow, ITechUtilisationRow } from "../../../types/api/reports";
import { IVehicle } from "../../../types/api/vehicle";
import { IDbsCheck, IRtwCheck } from "../compliance/callbacks";


export async function reportsList(qData: QData): Promise<AxiosResponse<TResponseWithQData<IReportsListResponse[]>>> {
    return axios.get(API_ENDPOINTS.REPORTS_LIST, {
        params: qData
    })
}

export async function createReport(data: IReportCreateResponse): Promise<AxiosResponse<TResponse<IReportCreateResponse>>> {
    return axios.post<TResponse<IReportCreateResponse>>(API_ENDPOINTS.REPORTS_CREATE, data)
}

export async function saveReport(data: IReportUploadPayload): Promise<AxiosResponse<TResponse<IReportsListResponse>>> {
    return axios.post<TResponse<IReportsListResponse>>(API_ENDPOINTS.REPORTS_UPLOAD, data)
}

export async function downloadReport(id: string): Promise<AxiosResponse> {
  const res = await axios.get(
    `${API_ENDPOINTS.REPORTS_DOWNLOAD}/${id}`,
  );
  return res;
}

export async function fetchJobsPerPeriod(from: string, to: string, group_by = "month"): Promise<AxiosResponse<TResponse<IJobsPeriodRow[]>>> {
  return axios.get(API_ENDPOINTS.REPORTS_JOBS_PER_PERIOD, { params: { from, to, group_by } });
}

export async function fetchRevenuePerPeriod(from: string, to: string, group_by = "month"): Promise<AxiosResponse<TResponse<IRevenuePeriodRow[]>>> {
  return axios.get(API_ENDPOINTS.REPORTS_REVENUE_PER_PERIOD, { params: { from, to, group_by } });
}

export async function fetchTechUtilisation(from: string, to: string): Promise<AxiosResponse<TResponse<ITechUtilisationRow[]>>> {
  return axios.get(API_ENDPOINTS.REPORTS_TECH_UTILISATION, { params: { from, to } });
}

export async function fetchFleetReport(): Promise<AxiosResponse<TResponseWithQData<IVehicle[]>>> {
  return axios.get(API_ENDPOINTS.VEHICLE_LIST, { params: { limit: 200, page: 1 } });
}

export async function fetchDbsReport(): Promise<AxiosResponse<TResponseWithQData<IDbsCheck[]>>> {
  return axios.get(API_ENDPOINTS.DBS_LIST, { params: { limit: 200, page: 1 } });
}

export async function fetchRtwReport(): Promise<AxiosResponse<TResponseWithQData<IRtwCheck[]>>> {
  return axios.get(API_ENDPOINTS.RTW_LIST, { params: { limit: 200, page: 1 } });
}
